import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ITHORDistribution } from '../../api/interfaces'
import { ThemeContext } from '../../App'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getTSVThorDistributionConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorswap', 'vthor_distribution', timeframe)) as ITHORDistribution[]
	const series1 = chartData.map((element: ITHORDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RICH_COUNT_50K }
	})
	const series2 = chartData.map((element: ITHORDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RICH_COUNT_10K }
	})
	const series3 = chartData.map((element: ITHORDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RICH_COUNT_1K }
	})

	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'wallets with >= 50k [vthor]',
			type: 'line',
			seriesGroup: '[wallet #]',
			color: 'green',
			unitSymbol: ''
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'wallets with >= 10k [vthor]',
			type: 'line',
			seriesGroup: '[wallet #]',
			color: 'orange',
			unitSymbol: ''
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'wallets with >= 1k [vthor]',
			type: 'line',
			seriesGroup: '[wallet #]',
			color: `${color}`,
			unitSymbol: ''
		}
	]
	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const TSVThorDistribution = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTSVThorDistributionConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="vTHOR Distribution"
			chartDesc="Distribution of vTHOR token holdings across different value brackets."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="334c0e26-3089-4698-ab67-1498402d42e6"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasLogScale={false}
		/>
	)
}

export default TSVThorDistribution
